import React, { useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { Container, Navbar, Button, Offcanvas } from 'react-bootstrap';
import { TextReducer } from '../components/Component';
import { useNavigate } from 'react-router';
import './Layout.css';
import { UserApi } from '../app/api/user.api';


const Layout = ({ children, activeMenu }) => {

  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);

  const user = UserApi(); 
    
  const fetchData = async () => { 
    const {data} = await user.findCurUser();
    return data.user; 
  }
  const { data } = useQuery({  queryKey: ["user"], queryFn: fetchData });

  const signout = () =>{
     localStorage.clear();
     navigate('/');
  }

  const menuItems = [
    { label: 'Commande', icon: 'bi-house-door', href: '/commandes-en-cours' },
    { label: 'Produit', icon: 'bi-box-seam', href: '/produit' },
    { label: 'Maintenance', icon: 'bi-tools', href: '/maintenance' },
    { label: 'Comptabilité', icon: 'bi-calculator', href: '/comptabilite' },
    { label: 'Generalité', icon: 'bi-gear', href: '/generalite' },
    { label: 'Utilisateur', icon: 'bi-people', href: '/utilisateurs' },
  ];

  return (
    <div className="layout-container">

      {/* ______________________ Desktop Sidebar ______________________ */}

      <aside className="sidebar d-none d-md-flex flex-column border-end">
        {/* Logo Section */}
        <div className="sidebar-header bg-dark">
          <div className={`badge-corner new text-light`}> </div>
           <div className="d-flex align-items-center justify-content-center bg-white rounded-circle">
              <img src='../favicon.png' alt='logo-ortega' className='' style={{ maxHeight: '30px' }}  />
            </div> 
          <span className="text-white fw-bold fs-4">ORTEGA</span>
        </div>
        {/* Navigation Menu */}
        <nav className="sidebar-nav flex-grow-1">
          { 
            menuItems.map((item, index) => {
              
              if (item.label === "Utilisateur" && data?.status !== "topadmin") {
                return null;
              }
              return (
                <a key={index} href={item.href} title={item.label} className={`nav-item d-flex align-items-center gap-3 px-4 py-4 ${ activeMenu === index + 1 ? 'active' : '' }`} >
                  <span className="nav-icon">
                    <i className={`me-2 bi ${item.icon}`} />
                  </span>
                  <span className="nav-label">{item.label}</span>
                </a>
              );
            })
          }
        </nav>
        {/* User Section */}
        <div className="sidebar-footer border-top bg-light">
          <UserSection data={data} />
          <button className="btn btn-outline-dark w-100 mt-3" onClick={ signout }>
              Déconnexion <i className="bi bi-chevron-right ms-2"></i>
          </button>
        </div>
      </aside>

      {/* ______________________ Mobile Navbar ______________________ */}
      
      <Navbar sticky="top" className="navbar-mobile d-md-none bg-dark py-2 navbar-dark">
        <Container fluid className="d-flex justify-content-between align-items-center">
          <Navbar.Brand className="me-0">
            <div className={`badge-corner new text-light`}> </div>
            <div className="d-flex align-items-center justify-content-center bg-white rounded-circle ms-3 me-1">
              <img src='../favicon.png' alt='logo-ortega' className='' style={{ maxHeight: '30px' }}  />
            </div> 
            <span className="text-white fw-bold fs-4"> ORTEGA </span>
          </Navbar.Brand>
          <Button variant="dark" onClick={() => setShowSidebar(true)} className="border-0">
            <i className="bi bi-list fs-3"></i>
          </Button>
        </Container>

        {/* ______________________ Mobile Offcanvas Menu ______________________ */}

        <Offcanvas show={showSidebar} placement="start" className="mobile-offcanvas text-light" onHide={() => setShowSidebar(false)} >
          <Offcanvas.Header closeButton closeVariant="white" className="bg-dark">
            <div className={`badge-corner new text-light`}> </div>
            <Offcanvas.Title className="text-white">
              <div className="d-flex align-items-center justify-content-center bg-white rounded-circle">
                <img src='../favicon.png' alt='logo-ortega' className='' style={{ maxHeight: '30px' }}  />
              </div> 
              <span className="text-white fw-bold fs-4"> ORTEGA </span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-0">
            <nav className="d-flex flex-column w-100">
              { menuItems.map((item, index) => (
                  <a key={index} href={item.href} title={item.label} className={`nav-item d-flex align-items-center gap-3 px-4 py-4 ${activeMenu === index + 1 ? 'active' : ''}`}>
                    <span className="nav-icon"> <i className={`me-2 bi ${item.icon}`} /> </span>
                    <span className="nav-label">{item.label}</span>
                  </a>
              ))}
            </nav>
            <div className="mt-auto p-4 border-top bg-light">     
              <UserSection data={data} />
              <button className="btn btn-outline-dark w-100 mt-3"onClick={ signout }>
                  Déconnexion <i className="bi bi-chevron-right ms-2"></i>
              </button>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </Navbar>

      {/* Main Content Area */}
      <main className="main-content">
        <div className="content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
};


function UserSection ({ data }) 
{
  return (
    <div className="border bg-white text-secondary rounded-top-3">
      <div className="d-flex align-items-center p-3">
        <div className="me-2">
          <div className="border bg-dark text-white rounded-circle d-flex align-items-center justify-content-center fw-bold small" style={{ width:40, height:40}}>
            { data?.fname ? data?.fname.charAt(0).toUpperCase() : ""}{ data?.lname ? data?.lname.charAt(0).toUpperCase() : ""}
          </div>
        </div>
        <div>
          <div className="fw-bold text-secondary small" title={ data?.fname + ' ' + data?.lname }> <TextReducer text={ data?.fname + ' ' + data?.lname} maxsize={16} /> </div>
          <div className="text-secondary small" title={ data?.email }> <TextReducer text={ data?.email } maxsize={16} /> </div>
        </div>
      </div>
    </div>
  ) 
}      




export default Layout;
